
export const countryMapping = {
  'spanje': 'Spanje',
  'spain': 'Spanje',
  'frankrijk': 'Frankrijk',
  'france': 'Frankrijk',
  'italië': 'Italië',
  'italie': 'Italië',
  'italy': 'Italië',
  'griekenland': 'Griekenland',
  'greece': 'Griekenland',
  'turkije': 'Turkije',
  'turkey': 'Turkije',
  'portugal': 'Portugal',
  'duitsland': 'Duitsland',
  'germany': 'Duitsland',
  'oostenrijk': 'Oostenrijk',
  'austria': 'Oostenrijk',
  'nederland': 'Nederland',
  'netherlands': 'Nederland',
  'belgië': 'België',
  'belgium': 'België',
  'egypte': 'Egypte',
  'egypt': 'Egypte',
  'marokko': 'Marokko',
  'morocco': 'Marokko',
  'tunesië': 'Tunesië',
  'tunisia': 'Tunesië',
  'cyprus': 'Cyprus',
  'malta': 'Malta',
  'kroatië': 'Kroatië',
  'croatia': 'Kroatië',
  // Verenigde Arabische Emiraten
  'verenigde arabische emiraten': 'Verenigde Arabische Emiraten',
  'uae': 'Verenigde Arabische Emiraten',
  'dubai': 'Verenigde Arabische Emiraten',
  'abu dhabi': 'Verenigde Arabische Emiraten',
  // Asia - met Nederlandse namen voor consistentie
  'thailand': 'Thailand',
  'vietnam': 'Vietnam',
  'indonesië': 'Indonesië',
  'indonesia': 'Indonesië',
  'maleisië': 'Maleisië',
  'malaysia': 'Maleisië',
  'singapore': 'Singapore',
  'japan': 'Japan',
  'china': 'China',
  'india': 'India',
  'sri lanka': 'Sri Lanka',
  'maldiven': 'Maldiven',
  'maldives': 'Maldiven',
  'cambodja': 'Cambodja',
  'cambodia': 'Cambodja',
  'myanmar': 'Myanmar',
  'laos': 'Laos',
  'filipijnen': 'Filipijnen',
  'philippines': 'Filipijnen',
  'zuid-korea': 'Zuid-Korea',
  'south korea': 'Zuid-Korea',
  'nepal': 'Nepal',
  'bhutan': 'Bhutan',
  // Americas
  'verenigde staten': 'Verenigde Staten',
  'united states': 'Verenigde Staten',
  'usa': 'Verenigde Staten',
  'canada': 'Canada',
  'mexico': 'Mexico',
  'costa rica': 'Costa Rica',
  'panama': 'Panama',
  'brazilië': 'Brazilië',
  'brazil': 'Brazilië',
  'argentinië': 'Argentinië',
  'argentina': 'Argentinië',
  'chili': 'Chili',
  'chile': 'Chili',
  'peru': 'Peru',
  'ecuador': 'Ecuador',
  'colombia': 'Colombia',
  'venezuela': 'Venezuela',
  'bolivia': 'Bolivia',
  'uruguay': 'Uruguay',
  'paraguay': 'Paraguay',
  // Caribbean
  'cuba': 'Cuba',
  'dominicaanse republiek': 'Dominicaanse Republiek',
  'dominican republic': 'Dominicaanse Republiek',
  'jamaica': 'Jamaica',
  'barbados': 'Barbados',
  'aruba': 'Aruba',
  'curaçao': 'Curaçao',
  'curacao': 'Curaçao',
  'bonaire': 'Bonaire',
  'sint maarten': 'Sint Maarten',
  'bahamas': 'Bahamas',
  'trinidad en tobago': 'Trinidad en Tobago',
  'antigua': 'Antigua',
  // Africa - met Nederlandse namen voor consistentie
  'zuid-afrika': 'Zuid-Afrika',
  'south africa': 'Zuid-Afrika',
  'kenia': 'Kenia',
  'kenya': 'Kenia',
  'tanzania': 'Tanzania',
  'botswana': 'Botswana',
  'namibië': 'Namibië',
  'namibia': 'Namibië',
  'zimbabwe': 'Zimbabwe',
  'zambia': 'Zambia',
  'ghana': 'Ghana',
  'senegal': 'Senegal',
  'gambia': 'Gambia',
  'kaapverdië': 'Kaapverdië',
  'cape verde': 'Kaapverdië',
  'ethiopia': 'Ethiopië',
  'ethiopië': 'Ethiopië',
  'madagascar': 'Madagascar',
  'seychellen': 'Seychellen',
  'seychelles': 'Seychellen',
  'mauritius': 'Mauritius',
  // Oceania
  'australië': 'Australië',
  'australia': 'Australië',
  'nieuw-zeeland': 'Nieuw-Zeeland',
  'new zealand': 'Nieuw-Zeeland',
  'fiji': 'Fiji',
  'vanuatu': 'Vanuatu',
  'tonga': 'Tonga',
  'samoa': 'Samoa',
  'palau': 'Palau',
  'mikronesië': 'Mikronesië',
  'micronesia': 'Mikronesië'
};
